import { render, staticRenderFns } from "./paymentBankDetails.vue?vue&type=template&id=7bad8d90"
import script from "./paymentBankDetails.vue?vue&type=script&lang=js"
export * from "./paymentBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports